export const SOCIAL_MEDIA_PLATFORMS = [
  { key: 'gmail', label: 'Gmail' },
  { key: 'microsoft365', label: 'Microsoft 365' },
  { key: 'instagram', label: 'Instagram' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'facebook', label: 'Facebook' },
  { key: 'telegram', label: 'Telegram' },
];
